import React, { useState, useEffect } from 'react'
import { View } from 'styles/reactnative'
import AnnouncementDetail from './AnnouncementDetail'
import AnnouncementList from './AnnouncementList'
import { AnnouncementContainer, AnnouncementSection } from './styles'
import { useFetcherPublic } from 'app/hooks/fetcher'

const Announcement = ({ title, searchshow = true }) => {
	const [show, setShow] = useState({
		show: false,
	})
	const [search, setSearch] = useState('')
	const [page, setPage] = useState(1)
	const [list, setList] = useState([])
	const { data } = useFetcherPublic('/notice/list?page=' + page + '&limit=10')
	const count = data?.result?.count || 0

	// 데이터 로드
	useEffect(() => {
		if (data?.result?.list) {
			setList(prev => {
				// 페이지가 1이면 새로운 리스트로 시작
				if (page === 1) return data.result.list
				// 중복 제거하여 새로운 데이터만 추가
				const newItems = data.result.list.filter(
					(newItem: any) => !prev.some((prevItem: any) => prevItem.id === newItem.id)
				)
				return [...prev, ...newItems]
			})
		}
	}, [data?.result?.list, page])

	return (
		<AnnouncementSection style={{}}>
			<AnnouncementContainer style={{ height: show ? 'auto' : 1200 }}>
				{show?.show ? (
					<AnnouncementDetail
						show={show}
						setShow={setShow}
						searchshow={title ? true : false}
					/>
				) : (
					<View
						style={{
							width: '100%',
							height: '100%',
							alignItems: 'flex-start',
							justifyContent: 'flex-start',
						}}>
						<AnnouncementList
							list={list}
							setList={setList}
							page={page}
							setPage={setPage}
							setShow={setShow}
							show={show}
							searchshow={title ? true : false}
							search={search}
							count={count}
						/>
					</View>
				)}
			</AnnouncementContainer>
		</AnnouncementSection>
	)
}

export default Announcement
